// Copyright (c) StrangeBee 2024

import React, { ReactNode } from 'react';
import { FormSubmitButton } from '@Atoms/Buttons/FormSubmitButton/FormSubmitButton';
import { useLocalMessage } from '@Helpers/locale';
import { THInput } from '@Molecules/Inputs/THInput/THInput';
import { THForm } from '@Molecules/THForm/THForm';
import { FormInstance } from 'antd';
import { THTextArea } from '@Molecules/Inputs/THTextArea/THTextArea';
import { ReportTemplateInput } from 'thehive-sdk';
export interface ReportTemplateFormValues {
    title: string;
    description?: string;
}

interface ReportTemplateFormProps {
    form: FormInstance;
    isValid: boolean;
    children?: ReactNode;
    defaultValues?: ReportTemplateInput;

    onChange: () => void;
    onCancel: () => void;
    onFinish?(values: ReportTemplateFormValues): void;
}

const ReportTemplateForm = ({
    form,
    isValid,
    children,
    defaultValues,
    onChange,
    onFinish,
    onCancel,
}: ReportTemplateFormProps) => {
    const i = useLocalMessage();
    return (
        <THForm<ReportTemplateFormValues>
            name="report-template-form"
            form={form}
            onValuesChange={onChange}
            onFinish={onFinish}
        >
            <THForm.Layout footer={<FormSubmitButton disabled={!isValid} onCancel={onCancel} />}>
                <THForm.Item
                    initialValue={defaultValues?.title}
                    name="title"
                    label={i('report-template.create.form.title.label')}
                    rules={[{ required: true, message: i('report-template.create.form.title.required') }]}
                >
                    <THInput placeholder={i('report-template.create.form.title.placeholder')} />
                </THForm.Item>

                <THForm.Item
                    initialValue={defaultValues?.description}
                    name="description"
                    label={i('report-template.create.form.description.label')}
                >
                    <THTextArea placeholder={i('report-template.create.form.description.placeholder')} />
                </THForm.Item>

                {children}
            </THForm.Layout>
        </THForm>
    );
};

export default ReportTemplateForm;
